<core-tabs-container position="columns" [style]="{ width: '100%' }">
  <core-tabs [attr.variant]="variant()">
    @for (tab of projectedTabs; track $index) {
      <core-tabs-item
        [attr.label]="tab.label"
        [attr.targetid]="tab.targetId"
        [attr.selected]="tab.selected"
        (tabSelected)="handleCoreTabSelect($index, tab.label, tab.id); $event.stopPropagation()">
      </core-tabs-item>
    }
  </core-tabs>

  <core-tabs-content>
    @for (tab of projectedTabs; track $index) {
      <div [id]="tab.targetId">
        <ng-container *ngTemplateOutlet="tab.component.contentTemplate"></ng-container>
      </div>
    }
  </core-tabs-content>
</core-tabs-container>
